import clsx from "clsx";
import homeHero from "~/assets/img/hero.svg";
import heroImg from "~/assets/img/home-hero.png";

const HomeHero = () => {
  return (
    <section
      className={clsx([
        "relative grid w-full grid-flow-row auto-rows-auto overflow-hidden bg-tan-lightest pt-16",
        "xl:pt-20",
        "2xl:pt-24",
      ])}
      style={{
        backgroundImage: `url(${homeHero})`,
        backgroundSize: "cover",
      }}
    >
      <h1
        className={clsx([
          "mx-auto px-10 pt-16 text-center font-logo text-4xl",
          "lg:text-5xl",
          "xl:px-0 xl:text-8xl",
        ])}
      >
        Flirt with your inner chef
      </h1>
      <h2
        className={clsx([
          "mx-auto max-w-[360px] pb-8 pt-5 text-center font-medium text-xl text-text-black opacity-90",
          "lg:max-w-[860px] lg:pb-12 lg:pt-8 lg:text-3xl",
          "xl:pb-16 xl:pt-10 xl:text-6xl",
        ])}
        itemProp="about"
      >
        Learn the <span className="font-logo">hows</span> and{" "}
        <span className="font-logo">whys</span> <br /> of making amazing food
      </h2>
      <div className="flex w-full items-center justify-center">
        <img
          src={heroImg}
          alt="Zest Screenshot"
          className={clsx([
            "block w-full max-w-[80%]",
            "md:max-w-[550px]",
            "lg:max-w-[690px]",
            "xl:max-w-[831px]",
          ])}
          itemProp="screenshot"
        />
      </div>
    </section>
  );
};

export default HomeHero;
